import { render, staticRenderFns } from "./pcproduct.vue?vue&type=template&id=82c7137c"
import script from "./pcproduct.vue?vue&type=script&lang=js"
export * from "./pcproduct.vue?vue&type=script&lang=js"
import style0 from "./pcproduct.vue?vue&type=style&index=0&id=82c7137c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports